import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "right_cont" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = {
  key: 1,
  class: "pagination"
}
const _hoisted_5 = {
  key: 1,
  class: "pagination"
}

import {reactive, ref, toRaw} from 'vue';
import * as publicRule from '@/store/rules.js';
import {ElMessage, TabsPaneContext, UploadProps} from "element-plus";
import {useRouter} from 'vue-router';
import { AREA_ID, AREA_NAME, FILE_URL, IMG_PREVIEW } from "@/config/const";
import { useStore } from "vuex";
import {getCInsProjectList, saveCorporateAndItemInformation, editCorporateAndItemInformation, getCInsNodeList, getCInsNodeAdd, getCInsCorporateInformationList} from "@/config/request";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const data = reactive({
    userInfo: {} as any,
})
data.userInfo = store.state.userInfomation

let fileUrl = ref(FILE_URL)
const activeName = ref('tab1');
const router = useRouter()
const projectcode = ref("");
const progressFormRef = ref(null);
const paginate = reactive({
    pageSize: 10,
    total: 0,
    pageSizes: [10, 20, 30],
    pageNo: 1,
})
const progressForm = reactive({
    projectId: "",
    projectProgress: '',
    files: "",
})
const addProject = async () => {
    activeName.value = 'tab2';
    formData.cInsProject.projectid = '';
    formData.cInsProject.projectcode = '';
    formData.cInsProject.projectname = '';
    formData.cInsProject.projectNature = '';
    formData.cInsProject.totalMoney = '';
    formData.cInsProject.incJgmc = '';
    formData.cInsProject.jbrMc = '';
    formData.cInsProject.jbrYddh = '';
    formData.cInsProject.industry = '';
    formData.cInsProject.scaleContent = '';
    formData.cInsProject.placeCode = '';
    formData.cInsProject.dwtyshxydm = data.userInfo.certificateSno;

    formData.cInsCorporateInformation.tyshdm = data.userInfo.certificateSno;
    formData.cInsCorporateInformation.qymc = '';
    formData.cInsCorporateInformation.type = '';
    formData.cInsCorporateInformation.fddbr = '';
    formData.cInsCorporateInformation.yyqxstart = '';
    formData.cInsCorporateInformation.yyqxend = '';
    formData.cInsCorporateInformation.zczb = '';
    formData.cInsCorporateInformation.clrq = '';
    formData.cInsCorporateInformation.djjg = '';
    formData.cInsCorporateInformation.hzrq = '';
    formData.cInsCorporateInformation.djzt = '';
    formData.cInsCorporateInformation.zs = '';
    formData.cInsCorporateInformation.jyfw = '';
    formData.cInsCorporateInformation.projectId = '';
}
const handleChange: UploadProps['onChange'] = (uploadFile, uploadFiles) => {}
const uploadFile = ref<any>([]);
const handleSuccess:UploadProps['onSuccess'] = (response: any,file,files) => {
    if(response.code === 0){
        ElMessage.success('上传成功')
        uploadFile.value.push(JSON.parse(response.result));
        progressForm.files = JSON.stringify(uploadFile.value);
    }else{
        ElMessage.error('上传失败')
    }
}
const saveOrUpdateProgress = async () => {
    activeName.value = 'tab3';
    progressForm.projectId = projectcode.value;

    const res = await getCInsNodeAdd(progressForm) as any;
    if(res.code === 200){
        ElMessage.success('提交成功');
        upload(projectcode.value);
    }else{
        ElMessage.success('提交失败');
    }
}
const paginate1 = reactive({
    pageSize: 10,
    total: 0,
    pageSizes: [10, 20, 30],
    pageNo: 1,
})
const disabled = ref(false);
const init = async () => {
    const param = {
        pageNo: paginate.pageNo,
        pageSize: paginate.pageSize,
        dwtyshxydm: data.userInfo.certificateSno,
    }
    const res = await getCInsProjectList(param) as any
    if(res.code === 200){
        const result = res.result
        projectList.value = result?.records
        paginate.total = result?.total || 0
    }
}
const handleCurrentChange = (index:any) => {
    paginate.pageNo = index
    init()
}
const handleSizeChange = (index:any) => {
    paginate.pageSize = index
    init()
}

const handleCurrentChange1 = (index:any) => {
    paginate1.pageNo = index
    upload(projectcode.value)
}
const handleSizeChange1 = (index:any) => {
    paginate1.pageSize = index
    upload(projectcode.value)
}

const formData = reactive({
    cInsProject: {
        projectcode: '',
        projectname: '',
        projectNature: '',
        totalMoney: '',
        incJgmc: '',
        jbrMc: '',
        jbrYddh: '',
        industry: '',
        scaleContent: '',
        areaid: AREA_ID,
        areaname: AREA_NAME,
        placeCode: '',
        projectid: '',
        dwtyshxydm: data.userInfo.certificateSno,
    },
    cInsCorporateInformation: {
        tyshdm: data.userInfo.certificateSno,
        qymc: '',
        type: '',
        fddbr: '',
        yyqxstart: '',
        yyqxend: '',
        zczb: '',
        clrq: '',
        djjg: '',
        hzrq: '',
        djzt: '',
        zs: '',
        jyfw: '',
        projectId: '',
    }
});

const toPath = (item:any) => {
  router.push({
    path:'/onlineReport',
    query: {
      projectcode:item.projectcode,
    }
  })
}
const edit = async (record: any) => {
    disabled.value = true;
    activeName.value = 'tab2';
    let data = toRaw(record);
    formData.cInsProject = data;
    await getList({projectId: data.projectcode, pageNo: paginate.pageNo, pageSize: paginate.pageSize});
}

const getList = async (params: { projectId: String; pageNo: number; pageSize: number; }) => {
    const res = await getCInsCorporateInformationList(params) as any
    if(res.code === 200){
        const result = res.result
        formData.cInsCorporateInformation = result?.records[0];
    }
}

const handleClick = (tab: TabsPaneContext, event: Event) => {
    if (activeName.value === 'tab1') {
        disabled.value = false;
        formData.cInsProject.projectid = '';
        formData.cInsProject.projectcode = '';
        formData.cInsProject.projectname = '';
        formData.cInsProject.projectNature = '';
        formData.cInsProject.totalMoney = '';
        formData.cInsProject.incJgmc = '';
        formData.cInsProject.jbrMc = '';
        formData.cInsProject.jbrYddh = '';
        formData.cInsProject.industry = '';
        formData.cInsProject.scaleContent = '';
        formData.cInsProject.placeCode = '';
        formData.cInsProject.dwtyshxydm = data.userInfo.certificateSno;

        formData.cInsCorporateInformation.tyshdm = data.userInfo.certificateSno;
        formData.cInsCorporateInformation.qymc = '';
        formData.cInsCorporateInformation.type = '';
        formData.cInsCorporateInformation.fddbr = '';
        formData.cInsCorporateInformation.yyqxstart = '';
        formData.cInsCorporateInformation.yyqxend = '';
        formData.cInsCorporateInformation.zczb = '';
        formData.cInsCorporateInformation.clrq = '';
        formData.cInsCorporateInformation.djjg = '';
        formData.cInsCorporateInformation.hzrq = '';
        formData.cInsCorporateInformation.djzt = '';
        formData.cInsCorporateInformation.zs = '';
        formData.cInsCorporateInformation.jyfw = '';
        formData.cInsCorporateInformation.projectId = '';
    }else if (activeName.value === 'tab2'){
        init();
    }
}
const reviewFile = (value: string) => {
    let file = JSON.parse(value);
    file.forEach((item: any) => {
        let fileId = item.fileId;
        if (fileId!==""){
            location.href = IMG_PREVIEW + fileId;
        }
    })

}
const uuid = () => {
    let s = [] as any
    let hexDigits = '0123456789abcdef'
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = '-'

    let uuid = s.join('')
    return uuid
}
const rules = {
    projectcode: [
        {required: true, message: '请输入项目编码', trigger: 'blur'}
    ],
    projectname: [
        {required: true, message: '请输入项目名称', trigger: 'blur'},
    ],
    incJgmc: [
        {required: true, message: '请输入申请单位名称', trigger: 'blur'},
    ],
    jbrYddh: [
        {required: true, message: '请输入移动电话', trigger: 'blur'},
        {required: true, validator: publicRule.isMobilePhone, trigger: "blur"},
    ],
    // agepid: [
    //     {required: true, message: '请输入联系人证件号码', trigger: 'blur'},
    //     {required: true, validator: publicRule.IDCard, trigger: "blur"},
    // ],
};
const formRef = ref();
const projectProgressList = ref([]);
const projectList = ref([]);

const upload = async (record: any) => {
    activeName.value = 'tab3';
    projectcode.value = record;
    const param = {
        pageNo: paginate1.pageNo,
        pageSize: paginate1.pageSize,
        projectId: projectcode.value,
    }
    const res = await getCInsNodeList(param) as any;
    if (res.code === 200) {
        const result = res.result
        projectProgressList.value = result?.records
        paginate1.total = result?.total || 0
    }
}
const saveOrUpdate = async () => {
    formData.cInsProject.dwtyshxydm = data.userInfo.certificateSno;
    formRef.value.validate(async (valid: any) => {
        if (valid) {
            if(!disabled.value){
                formData.cInsProject.projectid = uuid();
                formData.cInsCorporateInformation.projectId = formData.cInsProject.projectcode;
                const res = await saveCorporateAndItemInformation(formData) as any;
                if (res.code === 200 ) {
                    ElMessage.success('提交成功');
                    init();
                    activeName.value = 'tab1';
                }
            }else{
                formData.cInsCorporateInformation.projectId = formData.cInsProject.projectcode;
                const res = await editCorporateAndItemInformation(formData) as any
                if (res.code === 200) {
                    ElMessage.success('修改成功');
                }
            }
        } else {
            ElMessage.error('表单验证失败');
            return false;
        }
    })
}
init();

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "t6_title_h1" }, " 在线填报 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((activeName).value = $event)),
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "项目列表",
              name: "tab1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "never",
                  style: {"width":"100%"},
                  header: ""
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", { class: "card-header" }, [
                      _cache[31] || (_cache[31] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"18px"} }, "项目列表", -1)),
                      _createElementVNode("span", {
                        style: {"font-weight":"bold","font-size":"18px","float":"right","background-color":"#fff","color":"#359cf3","padding":"7px 20px","border-radius":"6px"},
                        onClick: addProject
                      }, "新增项目")
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      data: projectList.value,
                      border: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "projectname",
                          label: "项目名称",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "projectcode",
                          label: "项目编号",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "incJgmc",
                          label: "申请单位名称",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, { label: "操作" }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: ($event: any) => (toPath(scope.row))
                            }, {
                              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                _createTextVNode("在线申报", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: ($event: any) => (edit(scope.row))
                            }, {
                              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                _createTextVNode("修改信息", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: ($event: any) => (upload(scope.row.projectcode)),
                              style: {"margin":"0px","padding":"8px 15px"}
                            }, {
                              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                _createTextVNode("上传月报项目进展", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    (projectList.value.length === 0)
                      ? (_openBlock(), _createBlock(_component_el_empty, {
                          key: 0,
                          description: "暂无数据"
                        }))
                      : _createCommentVNode("", true),
                    (paginate.total > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_el_pagination, {
                            background: "",
                            onCurrentChange: handleCurrentChange,
                            onSizeChange: handleSizeChange,
                            layout: "sizes, prev, pager, next, ->, total",
                            "page-size": paginate.pageSize,
                            "page-sizes": paginate.pageSizes,
                            total: paginate.total
                          }, null, 8, ["page-size", "page-sizes", "total"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "基本信息",
              name: "tab2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  class: "demo-form-inline",
                  style: {"width":"100%"},
                  model: formData,
                  ref_key: "formRef",
                  ref: formRef
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      shadow: "never",
                      style: {"width":"100%"},
                      header: "项目信息"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "项目编号:",
                          prop: "projectcode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.projectcode,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.cInsProject.projectcode) = $event)),
                              placeholder: "",
                              onInput: _cache[1] || (_cache[1] = (v)=>(formData.cInsProject.projectcode = v.replace(/[^\a-\z\A-\Z0-9]/g, '')))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "项目名称:",
                          prop: "projectname"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.projectname,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.cInsProject.projectname) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "申请单位名称:",
                          prop: "incJgmc"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.incJgmc,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.cInsProject.incJgmc) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "项目建设地点:",
                          prop: "placeCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.placeCode,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.cInsProject.placeCode) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "联系人名称:",
                          prop: "jbrMc"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.jbrMc,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.cInsProject.jbrMc) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "联系人手机电话:",
                          prop: "jbrYddh"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.jbrYddh,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.cInsProject.jbrYddh) = $event)),
                              placeholder: "",
                              type: "tel",
                              min: "0",
                              max: "102400",
                              onInput: _cache[7] || (_cache[7] = ($event: any) => (formData.cInsProject.jbrYddh = String(formData.cInsProject.jbrYddh).replace(/[^\d]/g,'')))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "项目所属行业:",
                          prop: "industry"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.industry,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.cInsProject.industry) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "建设规模及内容:",
                          prop: "scaleContent"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.scaleContent,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.cInsProject.scaleContent) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "项目建设性质:",
                          prop: "projectNature"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.projectNature,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.cInsProject.projectNature) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "项目总投资(万元):",
                          prop: "totalMoney"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsProject.totalMoney,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.cInsProject.totalMoney) = $event)),
                              placeholder: "",
                              type: "number",
                              onInput: _cache[12] || (_cache[12] = (v)=>(formData.cInsProject.totalMoney=v.replace(/[^\d.]/g,'')))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_card, {
                      shadow: "never",
                      style: {"width":"100%"},
                      header: "企业信息"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "统一社会代码:",
                          prop: "tyshdm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.tyshdm,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.cInsCorporateInformation.tyshdm) = $event)),
                              placeholder: "",
                              onInput: _cache[14] || (_cache[14] = (v)=>(formData.cInsCorporateInformation.tyshdm = v.replace(/[^\a-\z\A-\Z0-9]/g, '')))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "企业名称:",
                          prop: "qymc"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.qymc,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.cInsCorporateInformation.qymc) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "类型:",
                          prop: "type"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.type,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.cInsCorporateInformation.type) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "法定代表人:",
                          prop: "fddbr"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.fddbr,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.cInsCorporateInformation.fddbr) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "注册资本(万元):",
                          prop: "zczb"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.zczb,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.cInsCorporateInformation.zczb) = $event)),
                              placeholder: "",
                              type: "number",
                              onInput: _cache[19] || (_cache[19] = (v)=>(formData.cInsProject.totalMoney=v.replace(/[^\d.]/g,'')))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "成立日期:",
                          prop: "clrq"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.clrq,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.cInsCorporateInformation.clrq) = $event)),
                              placeholder: "",
                              type: "date"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "营业期限自:",
                          prop: "yyqxstart"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.yyqxstart,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.cInsCorporateInformation.yyqxstart) = $event)),
                              placeholder: "",
                              type: "date"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "营业期限至:",
                          prop: "yyqxend"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.yyqxend,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.cInsCorporateInformation.yyqxend) = $event)),
                              placeholder: "",
                              type: "date"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "登记机关:",
                          prop: "djjg"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.djjg,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.cInsCorporateInformation.djjg) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "核准日期:",
                          prop: "hzrq"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.hzrq,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.cInsCorporateInformation.hzrq) = $event)),
                              placeholder: "",
                              type: "date"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "登记状态:",
                          prop: "djzt"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.djzt,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.cInsCorporateInformation.djzt) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "住所:",
                          prop: "zs"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.zs,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formData.cInsCorporateInformation.zs) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "经营范围:",
                          prop: "jyfw"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.cInsCorporateInformation.jyfw,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.cInsCorporateInformation.jyfw) = $event)),
                              placeholder: "",
                              type: "textarea"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  style: {"margin":"10px 50%"},
                  onClick: saveOrUpdate
                }, {
                  default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                    _createTextVNode("提交", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "月报项目进展",
              name: "tab3",
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  class: "demo-form-inline",
                  style: {"width":"100%"},
                  model: progressForm,
                  ref_key: "progressFormRef",
                  ref: progressFormRef
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "项目进展情况:",
                      prop: "projectname",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: progressForm.projectProgress,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((progressForm.projectProgress) = $event)),
                          placeholder: "",
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "附件:",
                      prop: "projectname",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_upload, {
                          class: "upload-demo",
                          action: _unref(fileUrl),
                          multiple: "",
                          modelValue: progressForm.files,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((progressForm.files) = $event)),
                          "on-change": handleChange,
                          "on-success": handleSuccess
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_button, { type: "primary" }, {
                                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                  _createTextVNode("上传月报项目进展", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["action", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      style: {"text-align":"center","margin":"0px 50%","padding":"10px"},
                      onClick: saveOrUpdateProgress
                    }, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createTextVNode("提交", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_el_table, {
                  data: projectProgressList.value,
                  border: "",
                  style: {"width":"100%","padding-top":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "序号",
                      align: "center",
                      type: "index"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "createTime",
                      label: "时间",
                      align: "center"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "projectProgress",
                      label: "项目进展情况",
                      align: "center"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "操作",
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (reviewFile(scope.row.files))
                        }, {
                          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                            _createTextVNode("查看", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]),
                (projectList.value.length === 0)
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 0,
                      description: "暂无数据"
                    }))
                  : _createCommentVNode("", true),
                (paginate1.total > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_el_pagination, {
                        background: "",
                        onCurrentChange: handleCurrentChange1,
                        onSizeChange: handleSizeChange1,
                        layout: "sizes, prev, pager, next, ->, total",
                        "page-size": paginate1.pageSize,
                        "page-sizes": paginate1.pageSizes,
                        total: paginate1.total
                      }, null, 8, ["page-size", "page-sizes", "total"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})